"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const __1 = require("../..");
const ListPopover_1 = require("./ListPopover");
const Loader_1 = require("./Loader");
const ContentContainer = ({ device, children }) => {
    return (React.createElement("div", { style: {
            alignItems: 'center',
            display: 'flex',
            minHeight: device === 'Mobile' ? 72 : 56,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${__1.titanium}`,
            justifyContent: 'space-between',
        } }, children));
};
const PredicateListInput = ({ device, popOverTargetParent, value, lists = [], onSelected, uploadList, }) => {
    const inputRef = React.useRef(null);
    const [isUploading, setIsUploading] = React.useState(false);
    if (value) {
        const createdAtFormated = new Date(value.createdAt).toLocaleDateString(undefined, {
            month: 'short',
            day: '2-digit',
        });
        console.log(createdAtFormated);
        return (React.createElement(ContentContainer, { device: device },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-around',
                    alignItems: 'flex-start',
                } },
                React.createElement(__1.Text, { text: value.name, size: device === 'Mobile' ? 'large' : 'medium' }),
                React.createElement(__1.Text, { text: `${value.size} rows · Created ${createdAtFormated}`, size: "small", textStyle: { color: __1.steel } })),
            React.createElement(__1.CircleCloseIcon, { fill: __1.turquoise, onClick: () => {
                    onSelected();
                } })));
    }
    if (isUploading) {
        return (React.createElement(ContentContainer, { device: device },
            React.createElement(Loader_1.default, null)));
    }
    return (React.createElement(ContentContainer, { device: device },
        React.createElement("input", { accept: ".csv,.txt", type: "file", ref: inputRef, style: { display: 'none' }, onChange: e => {
                setIsUploading(true);
                uploadList(e.currentTarget.files[0])
                    .then(l => onSelected(l))
                    .finally(() => setIsUploading(false));
            } }),
        React.createElement(__1.Button, { text: "Upload", type: "primary", size: "small", style: { outerStyle: { flex: '0 0 auto' } }, onClick: () => inputRef.current && inputRef.current.click() }),
        React.createElement(__1.Text, { size: "small", text: `Text or CSV file`, textStyle: {
                color: __1.steel,
                marginLeft: 14,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                flex: '1 1 auto',
            } }),
        React.createElement(ListPopover_1.default, { lists: lists, targetParent: popOverTargetParent, onSelected: onSelected })));
};
exports.default = PredicateListInput;
